define(['jquery', 'swiper/swiper-bundle.js'], function ($, Swiper) {
    "use strict";
    const SwiperConstructor = Swiper.default || Swiper;

    return {
        create: function ($swiperContainer) {
            let self = this;
            let imageSwiper = new SwiperConstructor($swiperContainer[0], {
                // Optional parameters
                direction: 'horizontal',
                loop: true,

                // If we need pagination
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction'
                },

                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },

                // And if we need scrollbar
                scrollbar: {
                    el: '.swiper-scrollbar',
                },
            });
        }
    };
});
